module.exports = __webpack_public_path__ + "static/media/tit_3.2cd37e98.png";